import { getOffsetLimitPaginationState } from '@/lib/pagination-utils';

export type ListingResultsCountAriaLabelKind = 'searchResults' | 'products' | 'items';

const KEY_PREFIX: Record<ListingResultsCountAriaLabelKind, string> = {
    searchResults: 'categoryPlp:stickyBar.resultsCountAriaLabel',
    products: 'categoryPlp:stickyBar.productsCountAriaLabel',
    items: 'categoryPlp:stickyBar.itemsCountAriaLabel',
};

export type ListingResultsCountTranslateFn = (key: string, options?: Record<string, string | number>) => string;

export function getListingResultsCountAriaLabel(
    t: ListingResultsCountTranslateFn,
    params: {
        kind: ListingResultsCountAriaLabelKind;
        total: number;
        pageNumber: number;
        paginationLimit: number;
    }
): string {
    const { kind, total, pageNumber, paginationLimit } = params;
    const prefix = KEY_PREFIX[kind];
    const { startIndex, endIndex, totalPages } = getOffsetLimitPaginationState({
        offset: (pageNumber - 1) * paginationLimit,
        limit: paginationLimit,
        total,
    });

    if (total === 0) {
        return t(`${prefix}_zero`);
    }

    if (totalPages > 1) {
        return t(`${prefix}Paginated`, {
            count: total,
            rangeStart: startIndex,
            rangeEnd: endIndex,
            pageNumber,
            totalPages,
        });
    }

    if (total === 1) {
        return t(`${prefix}_one`);
    }

    return t(`${prefix}_other`, {
        count: total,
        rangeStart: startIndex,
        rangeEnd: endIndex,
    });
}
